import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export enum ConversationTab {
  MY = "my",
  FIRM = "firm",
}

interface ConversationStore {
  activeTab: ConversationTab;
  setActiveTab: (tab: ConversationTab) => void;
}

export const useConversationList = create(
  persist<ConversationStore>(
    (set) => ({
      activeTab: ConversationTab.MY,
      setActiveTab: (tab: ConversationTab) => {
        set({ activeTab: tab });
      },
    }),
    {
      name: "conversationListStore",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
